'use strict';

function CompoundError(errors) {
  this.errors = errors;
  this.name = 'Compound error';
}

CompoundError.prototype = Error.prototype;

module.exports = CompoundError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/errors/compoundError.js
 ** module id = 565
 ** module chunks = 0
 **/